import { useLocation } from 'react-router-dom'
import { usePageTitle } from './PageTitleContext'
import { useEffect } from 'react'
import { adminRoute, authRoutes, routes } from '../../routes'

export default function PageTitleUpdater() {
    const { setTitle } = usePageTitle()
    const location = useLocation()

    useEffect(() => {
        const allRoutes = [...routes, ...authRoutes, adminRoute]
        const current = allRoutes.find(route => route.path === location.pathname)
        const pageName = current?.name ? `Strive2Help - ${current.name}` : 'Strive2Help'
        setTitle(pageName)
    }, [location.pathname, setTitle])

    return null
}
